import script from "./chart-bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./chart-bar.vue?vue&type=script&setup=true&lang=ts"

import "./chart-bar.vue?vue&type=style&index=0&id=7e78d128&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e78d128"]])

export default __exports__